import React from 'react';
import './Loader.css';

const Loader = ({ visible }) => {
  return (
    <div className={`loader ${!visible ? 'hidden' : ''}`} id="loader">
      <div className="loader-content">
        <div className="loader-text">
          <h1 className="loader-title">Every frame tells a story</h1>
          <p className="loader-subtitle">Timbalens Photography</p>
        </div>
        <div className="loader-progress">
          <div className="loader-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;

